/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { When } from "react-if";
import { ActionLogModal } from "~/views/events/EventsDetails/Tabs/Details/components/ActionLogModal";

type Props = {
  isOpen: boolean;
  close: () => void;
  outputUri: string;
};

export function ResourceDetailsActionLogs({ isOpen, close, outputUri }: Props) {
  return (
    <When condition={isOpen}>
      <ActionLogModal
        close={close}
        isOpen={isOpen}
        actionOutputUrl={outputUri}
        actionLogLabel={""}
      />
    </When>
  );
}
